import request from '@/utils/request'

//观展指南
export function getGuideList(params) {
  return request({
    url: '/api/guide',
    method: 'get',
    params
  })
}

